(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbita-image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orbita-carousel')) {
    class OrbitaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.timer = null;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.speed = Number(this.dataset.speed || 5000);
        this.autoplay = this.dataset.autoplay === 'true';

        if (!this.track || this.slides.length < 2) return;

        this.addEventListener('click', (event) => {
          const dot = event.target.closest('[data-dot]');
          if (!dot) return;
          this.goTo(Number(dot.dataset.index));
          this.restart();
        });

        this.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.changedTouches[0].clientX;
          },
          { passive: true }
        );

        this.addEventListener(
          'touchend',
          (event) => {
            this.touchEndX = event.changedTouches[0].clientX;
            const distance = this.touchEndX - this.touchStartX;
            if (Math.abs(distance) < 45) return;
            if (distance < 0) this.goTo(this.index + 1);
            if (distance > 0) this.goTo(this.index - 1);
            this.restart();
          },
          { passive: true }
        );

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.goTo(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(index) {
        const total = this.slides.length;
        this.index = (index + total) % total;
        this.track.style.transform = `translateX(-${this.index * 100}%)`;

        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === this.index ? 'true' : 'false');
        });
      }

      start() {
        if (!this.autoplay) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    customElements.define('orbita-carousel', OrbitaCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
